import { RadioGroup } from "@/components/elements/RadioGroup";
import { EMPLOYMENT_PERIOD, EMPLOYMENT_PERIOD_OPTIONS, getEmploymentPeriodLabel } from "@/features/management-ledger/constants/employment-period";
import { Box } from "@mui/material";
import { memo } from "react";

export type TUpdateEmploymentPeriodDraft = (entityId: number, value: number | null) => void;

type TProps = {
  entityId: number;
  value: number | null;
  isEditing: boolean;
  onChange: TUpdateEmploymentPeriodDraft;
};

export const LedgerEmploymentPeriodEditableCell = memo(
  ({ entityId, value, isEditing, onChange }: TProps) => {
    if (!isEditing) {
      return <span>{getEmploymentPeriodLabel(value)}</span>;
    }
    return (
      <Box
        sx={{
          display: "flex",
          // Pull the radio block up so its label sits on the same top line as the plain-text
          // columns; the radio control is taller than a text line and otherwise reads as lower.
          marginTop: "-8px",
          "& > .MuiStack-root": { flexWrap: "nowrap", gap: 1, alignItems: "center", marginTop: 0 },
          // Keep the dot and its label vertically centred together (don't reset the radio's own
          // margin-top, which would drop the label below the dot).
          "& .MuiFormControlLabel-root": { margin: 0, alignItems: "center !important" },
          "& .MuiTypography-root": { marginLeft: "-10px !important" },
        }}
      >
        <RadioGroup
          nonControl
          options={EMPLOYMENT_PERIOD_OPTIONS}
          value={value ?? EMPLOYMENT_PERIOD.FIXED_TERM}
          onChange={(next) => onChange(entityId, next != null ? Number(next) : null)}
        />
      </Box>
    );
  },
  (prev, next) => prev.value === next.value && prev.isEditing === next.isEditing && prev.entityId === next.entityId,
);
